import React from "react";

const Resume = () => {
    return (
        <>
            <h1>Timekeeper</h1>
        </>
    );
}

export {Resume};